import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => (
  {
    root: {
      width: '100%',
      minHeight: '100vh',
      backgroundColor: '#ccc',
      display: 'flex',
      justifyContent: 'center',
      backgroundPosition: "bottom left",
      backgroundRepeat: "no-repeat",
      backgroundSize: 'contain',
    },
  
     pageHeading: {
        color: '#1A4664',
        fontFamily: 'Montserrat',
        fontSize: '22px',
        fontWeight: '700',
        letterSpacing: '0.18px',
        lineHeight: '24px',
        marginBottom: 25,
        marginTop: 24
    },

    infoStrip: {
      backgroundColor: '#FFFFFF',
      width: '100%',
      padding: '20px 44px 20px 44px',
      border:'1px solid #B4B4B4',
      borderRadius : '10px',
      [theme.breakpoints.down('sm')]: {
        padding: 20
      },
    },
    
    infoBox: {
      backgroundColor: '#7EB1CC',
      margin: '40px',
      border:'1px solid #B4B4B4',
      borderRadius : '10px',
      padding: '15px'
    },
    
    icon: {
        margin: '20px 10px 20px 20px',
        fontSize: '30px',
        color: '#444444',
        height: '23px',
        width: '23px'
      },
    
    line: {
      border: '1px solid #E4E4E4'
    },

    container: {
      width: '120em',
      minWidth: "33.3em",
      marginTop: '3.6em',
      marginBottom: '6.6em',
      [theme.breakpoints.down('sm')]: {
        margin: '42px 16px',
      },
    },
 
    infoIcon: {
      padding: "6px 6px",
      fontSize: '30px',
      color: theme.palette.secondary.contrastText,
    },
  
    linkStyle: {
        fontFamily: "Montserrat",
        fontSize: '1em',
        color: '#007FFF',
        fontWeight: '600',
        letterSpacing: '0.6px',
        textDecoration: 'underline',
        cursor: "pointer"
      },
    
      btn: {
        backgroundColor: '#1A4664',
        fontFamily: "Montserrat",
        fontSize: 14,
        fontWeight: '600',
        marginRight: 16,
        height: 32,
        width: 186,
        color: '#FFFFFF',
        width: 186,
        marginBottom: 12,
        marginLeft: 42,
        '&:hover': {
            backgroundColor: '#1A4664'
          },
      },

      footerSection: {
        paddingTop: 24,
        paddingBottom: 40
      },

      cancelBtn: {
        width: 192,
        fontFamily: "Montserrat",
        fontSize: '1.6em',
        fontWeight: "600",
        letterSpacing: "0.53px",
        lineHeight: "19px",
        textAlign: "center",
        float: "right",
        border: "2px solid",
        height: '40px',
        boxShadow: '0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2)',
        borderColor: theme.palette.primary.main,
        [theme.breakpoints.down('xs')]: {
          width: 'auto',
        },
      },

      saveBtnBox: {
        float: "left",
        [theme.breakpoints.down('sm')]: {
          float: "right",
          paddingRight: 15
        }
      },
    
      saveBtn: {
        width: 228,
        fontFamily: "Montserrat",
        fontSize: 16,
        marginLeft: 20,
        fontWeight: "600",
        letterSpacing: "0.53px",
        lineHeight: "19px",
        textAlign: "center",
        height: '40px',
        [theme.breakpoints.down('xs')]: {
          width: 'auto',
        },
      },

      play: {
        color: '#235A86',
        borderRadius: '4px',
        border: '1.5px solid #235A86',
        backgroundColor: '#FFFFFF',
        cursor: "pointer",
        textAlign: 'center',
        fontFamily: 'Montserrat',
        fontSize: '14px',
        fontWeight: '600',
        lineHeight: 'normal',
        textTransform: 'uppercase',
        width: '230px',
        float: 'right',
        '&:hover': {
            backgroundColor: '#FFFFFF'
          },
        [theme.breakpoints.down('xs')]: {
           fontSize: 12,
           float: 'left',
           width: '212px'
        }
      },

      expand_icon: {
        color: '#000000',
        cursor:'pointer'
      },

      collapse_icon: {
        color: '#000000',
        marginRight: 10,
        transform: 'rotate(180deg)',
        cursor:'pointer'
      },
      
      transactionText: {
        color: '#626262',
        fontSize: '16px',
        fontWeight: '600',
        lineHeight: '10px',
        fontFamily: 'Inter',
        borderRadius: '0px 5px 0px 0px',
        borderBottom: '1px solid #BFBFBF',
        marginBottom: '8px',
        marginTop: '8px',
        [theme.breakpoints.down('sm')]: {
          fontSize: '14px',
          fontWeight: '600',
          lineHeight: '15px',
        },
      },
      
      hardshipContainer: {
        margin: 12
      },

      procedureToFill: {
        color: '#121D22',
        fontFamily: "Montserrat",
        fontSize: 16,
        lineHeight: "22px",
        fontWeight: '700'
      },

      readInst: {
        color: '#121D22',
        fontFamily: "Montserrat",
        fontSize: 16,
        lineHeight: "24px",
        fontWeight: '400'
      },

      line: {
        border: '1px solid #D9D9D9'
      },

      instruction: {
        color: '#121D22',
        fontFamily: "Montserrat",
        fontSize: 16,
        lineHeight: "32px",
        fontWeight: '400'
      },

      downloadInst: {
        color: '#121D22',
        fontFamily: "Montserrat",
        fontSize: 16,
        lineHeight: "32px",
        fontWeight: '600'
      },

      textAreaValidation: {
        color: '#202020',
        float: 'right'
      },
      
      datePicker: {
        [theme.breakpoints.down('sm')]: {
          paddingTop: '20px',
          paddingLeft: '0px'
        },
      },

      radioStyle: {
        padding: '0 5px',
        color: "#7B8390",
        '&.Mui-checked': {
          color: "#202020 !important",
        }
      },
    
      activeLabel: {
        color: "#121D22",
        fontFamily: "Montserrat",
        fontSize: 16,
        fontWeight: "500"
      },

      checkboxLabel: {
        color: "#121D22 !important",
        fontFamily: "Montserrat",
        fontSize: 16,
        fontWeight: "500"
      },
    
      radioLabel: {
        color: "rgba(0,0,0,0.74)",
        fontFamily: "Montserrat",
        fontSize: " 16px",
        fontWeight: "500",
      },
    
      marginFixed: {
        marginTop: 14
      },

      fileUpload:{
        display:'flex',
        alignItems:'center',
        marginTop:'10px',
        marginBottom:'15px',
        [theme.breakpoints.down('sm')]: {
          flexDirection:'column',
          alignItems:'normal',
          clear:'both',
          width: '90%'
        },
      },

      fileButton:{
        borderRadius: '4px',
        border: '1px solid #EDB36A',
        background: '#FFF',
        height: '32px'
      },

      fileBtnDisable:{
        borderRadius: '4px',
        background: '#B4B4B4',
        margin:'0px 15px',
        height: '32px'
      },

      chooseFile:{
        color: '#121D22',
        fontFamily: 'Montserrat',
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: '500',
        lineHeight: 'normal',
        marginRight:'15px',
        [theme.breakpoints.down('sm')]: {
          paddingTop: '5px'
        },
      },

      uploadedImageContainer:{
        paddingLeft:'20px',
        [theme.breakpoints.down('sm')]: {
          paddingRight:'0px',
        },
      },

      uploadedImage:{
        borderBottom: '3px solid #198100',
        color: '#202020',
        fontFamily: 'Montserrat',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: '16px',
        paddingBottom: '4px',
        display: 'flex',
      },

      imageText: {
        width: '220px',
        color: '#007FFF',
        fontFamily: 'Montserrat',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: '16px',
        textDecoration: 'underline',
        paddingLeft: 10,
        paddingTop: 2,
        wordWrap: 'break-word',
        cursor: 'pointer',
        [theme.breakpoints.down('sm')]: {
          width:'235px'
        },
      },

      nextBtn: {
        width: 214,
        fontFamily: "Montserrat",
        fontSize: 16,
        marginLeft: 20,
        fontWeight: "600",
        letterSpacing: "0.53px",
        lineHeight: "19px",
        textAlign: "center",
        height: '40px',
        [theme.breakpoints.down('xs')]: {
          width: 'auto',
        },
      },

      attachFile: {
        color: '#202020',
        fontFamily: "Montserrat",
        fontSize: 16,
        lineHeight: "22px",
        fontWeight: '500'
      },

      accordianHeading: {
        color: '#121D22',
        fontFamily: "Montserrat",
        fontSize: 16,
        fontWeight: '700'
      },
      
      textArea: {
        color: "#202020",
        fontFamily: "Montserrat",
        fontSize: "14px",
        fontWeight: 500,
        width: '100%',
        padding: "10px",
        height: '56px',
        border: 'none',
        backgroundColor: 'transparent',
        outline: 'none',
        borderRadius: '4px',
        border: '1px solid #9E9E9E',
        "&::placeholder": {    
          fontSize: '14px', 
          color: 'rgba(0, 0, 0, 0.54)',
          fontSize: '1rem',
          fontFamily: 'Montserrat',
          fontWeight: 400,
          lineHeight: 1
          }
     },

     infoTopBox: {
      width: '100%',
      backgroundColor: '#F4F4F4',
      borderRadius: 8,
      borderRadius: '4px',
      border: "1px solid #D9D9D9",
      marginBottom: 20,
      marginTop: 5
    },

    
    info: {
      color: "#4D4D4D",
      fontFamily: "Montserrat",
      fontSize: '14px',
      fontWeight: "500",
      [theme.breakpoints.down('sm')]: {
        fontSize: '16px',
        fontWeight: "500",
        lineHeight: "25px",
        textAlign: "start",
      }
    },

    uploadedImagesBox:{
      paddingRight:'40px',
      [theme.breakpoints.down('sm')]: {
        paddingRight:'0px',
      },
    },

    uploadedImg:{
      borderBottom: '3px solid #198100',
      color: '#202020',
      fontFamily: 'Montserrat',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: '600',
      lineHeight: '16px',
      paddingBottom: '10px',
      marginBottom: '20px',
      display: 'flex',
      marginTop: 18
    },

    fileUploadSection:{
      marginTop:'10px',
      marginBottom:'15px',
      marginLeft: '26px',
      [theme.breakpoints.down('sm')]: {
        flexDirection:'column',
        alignItems:'normal',
        clear:'both',
        width: '90%'
      },
    },

    uploadDocsSection: {
      margin: 12
    },

    selectApply: {
      color: '#121D22',
      fontFamily: "Montserrat",
      fontSize: 16,
      lineHeight: "22px",
      fontWeight: '700',
      marginTop: 20,
      marginBottom: 20
    },

    supportDocDesc: {
      color: '#4D4D4D',
      fontFamily: "Montserrat",
      fontSize: 14,
      lineHeight: "22px",
      fontWeight: '500'
    },

    supportDocError: {
      color: 'red',
      fontFamily: "Montserrat",
      fontSize: 12,
      lineHeight: "22px",
      fontWeight: '500'
    },

    stepperLabel: {
      color: '#121D22',
      fontFamily: "Montserrat",
      fontSize: 16,
      lineHeight: "22px",
      fontWeight: '700',
      cursor: 'pointer'
    },

    disableStepperLabel: {
      color: '#121D22',
      fontFamily: "Montserrat",
      fontSize: 16,
      lineHeight: "22px",
      fontWeight: '500'
    },

    chooseFileButton:{
      borderRadius: '4px',
      border: '1px solid #EDB36A',
      background: '#FFF',
      height: '32px',
      margin: "0px 10px"
    },

    signedAgreement: {
      color: '#121D22',
      fontFamily: "Montserrat",
      fontSize: 14,
      lineHeight: "22px",
      fontWeight: '500'
    },

    listingSection: {
      margin: '25px 0px'
    },

    realtorSection: {
      margin: '25px 0px'
    },

    inputStyle: {
      // color: "#535D6D",
      fontFamily: "Montserrat",
      fontSize: 16,
      fontWeight: "600",
      '&::placeholder': {
          color: '#9E9E9E',
          opacity: 1,
        },
    },

    inputContainer: {
      margin: '10px 10px 10px 0px'
    },

    labelAsterisk: {
      color: "red"
    },

    fileText: {
      width: '244px',
      color: '#007FFF',
      fontFamily: 'Montserrat',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: '600',
      lineHeight: '16px',
      textDecoration: 'underline',
      paddingLeft: 10,
      paddingTop: 2,
      wordWrap: 'break-word',
      cursor: 'pointer',
      [theme.breakpoints.down('sm')]: {
        width:'235px'
      },
    },

    heading: {
      color: '#121D22',
      fontFamily: "Montserrat",
      fontSize: 18,
      lineHeight: "22px",
      fontWeight: '700',
      [theme.breakpoints.down('sm')]: {
        fontSize: 14
      },
    },

    decision: {
      color: '#4D4D4D',
      fontFamily: "Montserrat",
      fontSize: 14,
      lineHeight: "18px",
      fontWeight: '500'
    },

    errorText: {
      color: "red",
      fontFamily: "Montserrat",
      fontSize: "16px",
      fontWeight: "600",
      letterSpacing: "0.31px",
      lineHeight: "18px",
      marginBottom: '12px'     
    },
 
    loadingRoot: {
      width: '100%',
      height: '100vh',
      padding: '6.4em 6%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#ccc',
    },

    fileBtnDisable:{
      borderRadius: '4px',
      background: '#949494',
      marginRight:'15px',
    },

    textareaSection: {
      marginTop: 16,
      marginBottom: 16
    },

    specifyOtherIncome: {
      color: "#535D6D",
      fontFamily: "Montserrat",
      fontSize: 16,
      fontWeight: "600",
      width: '50%',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    
    textField: {
      // color: "#9E9E9E",
      fontFamily: "Montserrat",
      fontSize: " 16px",
      fontWeight: '600'
    },


  }
));

